import { ObjectHelper } from "../../../Helpers/ObjectHelper";
import { IJNativeEvent } from "../../../JNative";
import { Property } from "../../../RadObject";
import { RadHistory } from "../../RadHistory";
import { Control, IControl } from "../Control";
import { NAMESPACE } from "./_Namespace";

export type ActionButtonMixinPropertyValues = {
    action: string;
    actionArguments: string;
    actionTarget: IControl;
    actionTargetControlClass: string;
    actionTargetId: string;
    actionTargetSelector: string;
};

export type ActionButtonMixinProperties = {
    [name in keyof ActionButtonMixinPropertyValues]: Property<ActionButtonMixinPropertyValues[name]>
};

export interface IActionButtonMixin extends IControl, ActionButtonMixinProperties
{
}

export class ActionButtonMixin
{
    public static classNamespace = NAMESPACE + "ActionButtonMixin";
    public static className = "ActionButtonMixin";
    public static get classFullName() { return `${this.classNamespace}.${this.className}`; }

    private static applyActionButtonProperties(control: IActionButtonMixin)
    {
        let
            actionTarget = control.actionTarget.get();

        const
            actionTargetId = control.actionTargetId.get(),
            actionTargetControlClass = control.actionTargetControlClass.get(),
            actionTargetSelector = control.actionTargetSelector.get();

        if (!actionTarget)
        {
            if (actionTargetId)
            {
                actionTarget = Control.find("#" + actionTargetId);

                if (!actionTarget)
                    throw new Error("Cannot find action target control using the supplied id.");
            }
            else if (actionTargetControlClass)
            {
                let
                    controlClass = ObjectHelper.propertyValueByPathGet(window, actionTargetControlClass);

                if (!controlClass)
                {
                    const
                        controlNamespacePath = control.$$element.get()?.closest("[data-control-namespace]").attr("data-control-namespace");

                    let
                        controlNamespace;

                    if (typeof controlNamespacePath === "string")
                        controlNamespace = ObjectHelper.propertyValueByPathGet(window, controlNamespacePath);

                    if (controlNamespace)
                        controlClass = ObjectHelper.propertyValueByPathGet(controlNamespace, actionTargetControlClass);
                }

                if (!controlClass)
                    throw new Error("Cannot find the supplied control class specified for the action target.");

                actionTarget = control;

                while (actionTarget)
                {
                    if (actionTarget instanceof controlClass)
                        break;

                    actionTarget = actionTarget.parentControlGet() ?? null;
                }

                if (!actionTarget)
                    throw new Error("Cannot find action target control using the supplied control class.");
            }
            else if (actionTargetSelector)
            {
                actionTarget = control.$$element.get()?.closest(actionTargetSelector).radControl();

                if (!actionTarget)
                    throw new Error("Cannot find action target control using the supplied selector.");
            }

            if (actionTarget)
                control.actionTarget.set(actionTarget);
        }

        if (actionTarget)
        {
            const
                action = control.action.get();

            if (action && typeof (actionTarget as any)[action] !== "function")
                throw new Error("Action target does not support the action \"" + action + "\".");
        }
    }
    public static processActionButtonClick(control: IActionButtonMixin, evt: IJNativeEvent)
    {
        this.applyActionButtonProperties(control);

        const
            action = control.action.get(),
            actionArguments = control.actionArguments.get(),
            actionTarget = control.actionTarget.get();

        if (actionTarget && action)
        {
            evt.preventDefault();
            return (actionTarget as any)[action].apply(actionTarget, actionArguments);
        }
        else if (action)
        {
            switch (action)
            {
                case "back":

                    evt.preventDefault();

                    const
                        history = window.history,
                        navigator = (window.navigator as any)

                    if (RadHistory.pushStateCounter > 0)
                        history.back();
                    else if (navigator?.app?.exitApp)
                        navigator.app.exitApp();

                    return Promise.resolve();
            }
        }

        return null;
    }
}